const MALFUNCTION_DISPLAY_NAMES = {
  "0": "Pothole",
  pothole: "Pothole",
  potholes: "Pothole",
  longitudinal_crack: "Longitudinal Crack",
  transverse_crack: "Transverse Crack",
  alligator_crack: "Alligator Crack",
  other: "Other Road Damage",
};

export function getMalfunctionTypeLabel(detection) {
  if (detection?.malfunction_type_display) {
    return detection.malfunction_type_display;
  }

  const type = String(detection?.malfunction_type ?? "").trim();
  if (!type) return "Unknown Type";

  const normalized = type.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  if (MALFUNCTION_DISPLAY_NAMES[normalized]) {
    return MALFUNCTION_DISPLAY_NAMES[normalized];
  }

  return normalized
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
